import Button from "./Button";
import React from "react";
import { useReducer } from "react";
import { reducer,initialState } from "../reducers/reducers";
import '../App.css'; // Optional: If you're using an external CSS file
const Confirm = ({onDelete,onCancel, message = 'Estas seguro de que quieres borrar el item?'}) => {
    
    const [state, dispatch] = useReducer(reducer, initialState);
    return(
        <div className="modal-overlay">
        <div className="confirm-modal">
            {message}
            <div className="invisible-horizontal-container">
                <Button text="Si" onClick={()=>onDelete()}color="#DF7476"></Button>
                <Button text="Cancelar" onClick={()=>onCancel()} color="#000000"></Button>
            </div>
        </div>
        </div>
    )
}
export default Confirm;